// Copyright: IQGeo Limited 2010-2022
import myw from 'myWorld/base/core';
import './formComponent';

/**
 * @class  Input
 * @param  {string}   options.value       input value
 * @param  {string}   options.placeholder Text to show in the box when there is no value
 * @param  {function} options.onChange    callback fired onChange
 * @param  {function} options.onKeyUp     callback fired onKeyUp
 *
 * @example
 *     new myw.Input({value: "Hello World", onChange: function() {} })
 *
 * @extends {FormComponent}
 */
myw.Input = myw.FormComponent.extend({
    tagName: 'input',
    className: 'text ui-input',

    events: {
        keyup: '_onKeyUp',
        change: '_onChange'
    },

    initialize(options) {
        myw.FormComponent.prototype.initialize.call(this, options);
        if (this.options.placeholder) {
            this.$el.attr('placeholder', this.options.placeholder);
        }
    },

    _onKeyUp() {
        const options = this.options;
        if (options.onKeyUp) {
            options.onKeyUp.call({}, this);
        }
    }
});

myw.View.prototype.componentMapping['input'] = myw.Input;

export default myw.Input;
